import './Floating.b03a65f76ba89a4472cc2e7709cee320.css';
export default {"menu":"_menu_1yv8c_1","small":"_small_1yv8c_1"};